import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.releases');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { currentKstDateCompact, formatKstDateTime } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-releases',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.releases/view.scss */
:host {
  display: block;
  height: 100%;
}

.release-page {
  max-width: 1180px;
  margin: 0 auto;
  padding: 34px 32px 60px;
}

.page-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
}

.page-actions {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.page-actions label {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.page-actions label span {
  color: #667770;
  font-size: 9px;
  font-weight: 750;
}

.page-actions select {
  min-width: 210px;
  height: 36px;
  border: 1px solid #cad9d2;
  border-radius: 8px;
  padding: 0 10px;
  color: #315e4c;
  background: #fff;
  font: inherit;
  font-size: 11px;
}

.page-heading span, .freeze-panel > header span, .version-panel > header span {
  color: #646bab;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.13em;
}

.page-heading h1 {
  margin: 6px 0 0;
  color: #292c46;
  font-size: 25px;
  letter-spacing: -0.035em;
}

.page-heading p {
  margin: 8px 0 0;
  color: #85879a;
  font-size: 10px;
}

.page-heading button {
  padding: 8px 11px;
  border: 1px solid #dfe0e8;
  border-radius: 8px;
  color: #5c6077;
  background: #fff;
  font-family: inherit;
  font-size: 9px;
}

.boundary-notice {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 13px 15px;
  border-radius: 10px;
  color: #4f568b;
  background: #f0f1fa;
  gap: 18px;
}

.boundary-notice strong {
  font-size: 8px;
  letter-spacing: 0.1em;
  white-space: nowrap;
}

.boundary-notice p {
  margin: 0;
  font-size: 8px;
}

.state-card {
  margin-top: 16px;
  padding: 38px;
  border: 1px dashed #d8d9e3;
  border-radius: 12px;
  color: #797b8f;
  background: #fafafd;
  text-align: center;
}

.state-card strong {
  display: block;
  color: #45485f;
  font-size: 11px;
}

.state-card p {
  margin: 7px 0 0;
  font-size: 8px;
}

.freeze-panel, .version-panel {
  margin-top: 16px;
  padding: 17px;
  border: 1px solid #dedfe8;
  border-radius: 13px;
  background: #fff;
}

.freeze-panel > header, .version-panel > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.freeze-panel h2, .version-panel h2 {
  margin: 4px 0 0;
  color: #393c54;
  font-size: 14px;
}

.freeze-panel > header small, .version-panel > header small {
  color: #9294a4;
  font-size: 8px;
}

.freeze-panel > header strong {
  color: #447665;
}

.freeze-grid {
  display: grid;
  margin-top: 14px;
  grid-template-columns: 1fr 270px;
  gap: 13px;
}

.batch-list {
  display: grid;
  align-content: start;
  gap: 7px;
}

.batch-list button {
  display: grid;
  align-items: center;
  padding: 11px;
  border: 1px solid #e0e1e8;
  border-radius: 9px;
  color: #55586d;
  background: #fff;
  font-family: inherit;
  text-align: left;
  grid-template-columns: 24px 1fr auto;
  gap: 9px;
}

.batch-list button.selected {
  border-color: #666fa9;
  background: #f3f4fb;
  box-shadow: inset 0 0 0 1px #666fa9;
}

.batch-list button:disabled {
  opacity: 0.5;
}

.batch-list .check {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 1px solid #d6d8e3;
  border-radius: 5px;
  color: #fff;
  background: #fff;
  font-size: 9px;
}

.batch-list button.selected .check {
  border-color: #5c66a1;
  background: #5c66a1;
}

.batch-list strong, .batch-list small {
  display: block;
}

.batch-list strong {
  font-size: 9px;
}

.batch-list small {
  margin-top: 4px;
  color: #999aa7;
  font-size: 7px;
}

.batch-list .batch-blocker {
  color: #9a6136;
  line-height: 1.45;
}

.batch-list em {
  padding: 4px 6px;
  border-radius: 5px;
  color: #477769;
  background: #eaf6f1;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.empty-inline {
  padding: 28px;
  border: 1px dashed #dedfe7;
  border-radius: 9px;
  color: #8e90a0;
  font-size: 8px;
  text-align: center;
}

.release-guidance {
  display: grid;
  gap: 5px;
  padding: 14px;
  border: 1px solid #f0d7ba;
  border-radius: 9px;
  color: #80572f;
  background: #fffaf4;
  font-size: 10px;
}

.release-guidance strong {
  font-size: 11px;
}

.release-guidance a {
  width: fit-content;
  color: #176d54;
  font-weight: 750;
  text-decoration: none;
}

.freeze-grid aside {
  padding: 13px;
  border-radius: 9px;
  background: #f7f7fa;
}

.freeze-grid label span {
  display: block;
  margin-bottom: 6px;
  color: #777ca5;
  font-size: 7px;
  font-weight: 850;
}

.freeze-grid input {
  box-sizing: border-box;
  width: 100%;
  padding: 9px;
  border: 1px solid #dcdee7;
  border-radius: 7px;
  color: #41445a;
  background: #fff;
  font-family: inherit;
  font-size: 9px;
}

.freeze-grid dl {
  display: grid;
  margin: 12px 0;
  gap: 6px;
}

.freeze-grid dl div {
  display: flex;
  justify-content: space-between;
}

.freeze-grid dt, .freeze-grid dd {
  margin: 0;
  color: #858797;
  font-size: 8px;
}

.freeze-grid dd {
  color: #45485e;
  font-weight: 750;
}

.freeze-grid aside > button {
  width: 100%;
  padding: 10px;
  border: 0;
  border-radius: 7px;
  color: #fff;
  background: #545d99;
  font-family: inherit;
  font-size: 8px;
  font-weight: 750;
}

button:disabled {
  opacity: 0.45;
}

.version-list {
  display: grid;
  margin-top: 13px;
  gap: 9px;
}

.version-list > article {
  padding: 14px;
  border: 1px solid #e0e1e8;
  border-radius: 10px;
}

.version-list > article[data-status=RELEASED] {
  border-color: #cfe1db;
  background: #fbfefd;
}

.version-list > article > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.version-list > article > header > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.version-list > article > header span {
  color: #3f4259;
  font-size: 12px;
  font-weight: 850;
}

.version-list > article > header em {
  padding: 4px 7px;
  border-radius: 5px;
  color: #4f588f;
  background: #edf0fa;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.version-list > article[data-status=RELEASED] > header em {
  color: #427262;
  background: #e8f5f0;
}

.version-list > article > header button {
  padding: 8px 10px;
  border: 0;
  border-radius: 7px;
  color: #fff;
  background: #535b98;
  font-family: inherit;
  font-size: 8px;
  font-weight: 750;
}

.version-list > article > dl {
  display: grid;
  margin: 12px 0 0;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.version-list > article > dl div {
  padding: 9px;
  border-radius: 7px;
  background: #f7f7fa;
}

.version-list dt, .version-list dd {
  margin: 0;
}

.version-list dt {
  color: #9395a4;
  font-size: 7px;
}

.version-list dd {
  margin-top: 4px;
  color: #4f5268;
  font-size: 8px;
}

.version-list code {
  color: #545c93;
  font-family: monospace;
  font-size: 7px;
}

.artifact-list {
  display: grid;
  margin-top: 10px;
  gap: 7px;
}

.artifact-list > article {
  padding: 10px;
  border-radius: 8px;
  background: #f0f7f4;
}

.artifact-list > article > div {
  display: flex;
  justify-content: space-between;
}

.artifact-list strong {
  color: #486e63;
  font-size: 8px;
}

.artifact-list span {
  color: #7d948d;
  font-size: 7px;
}

.artifact-list ul {
  display: grid;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
  gap: 4px;
}

.artifact-list li {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.artifact-list li span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.artifact-list p {
  margin: 7px 0 0;
  color: #9a5151;
  font-size: 7px;
}

@media (max-width: 760px) {
  .release-page {
    padding: 26px 18px 44px;
  }
  .freeze-grid {
    grid-template-columns: 1fr;
  }
  .version-list > article > dl {
    grid-template-columns: repeat(2, 1fr);
  }
  .boundary-notice {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
}
/* Drive UI surface */
.release-page {
  max-width: 1540px;
  min-height: 620px;
  box-sizing: border-box;
  margin: 24px auto 36px;
  padding: 0 22px 22px;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  color: #22312c;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
}

.page-heading {
  min-height: 70px;
  align-items: center;
  margin: 0 -22px;
  padding: 0 22px;
  border-bottom: 1px solid #e7ecea;
}

.page-heading span, .freeze-panel > header span, .version-panel > header span {
  color: #18845f;
  font-size: 11px;
  letter-spacing: 0.04em;
}

.page-heading h1 {
  margin: 3px 0;
  color: #172f27;
  font-size: 20px;
}

.page-heading p {
  margin: 4px 0 0;
  color: #697a73;
  font-size: 12px;
}

.page-heading button {
  min-height: 36px;
  padding: 0 13px;
  border-color: #cad9d2;
  color: #315e4c;
  font-size: 11px;
}

.boundary-notice {
  border: 1px solid #cde1d8;
  color: #285c48;
  background: #f2faf6;
}

.boundary-notice strong, .boundary-notice p {
  font-size: 11px;
}

.state-card {
  border-color: #d5dfdb;
  color: #718078;
  background: #fff;
}

.state-card strong {
  color: #34483f;
  font-size: 13px;
}

.state-card p {
  font-size: 11px;
}

.freeze-panel, .version-panel {
  border-color: #dce5e1;
  border-radius: 12px;
}

.freeze-panel h2, .version-panel h2 {
  color: #30483e;
  font-size: 16px;
}

.freeze-panel > header small, .version-panel > header small {
  font-size: 11px;
}

.batch-list button {
  border-color: #e0e7e4;
  color: #40544d;
}

.batch-list button.selected {
  border-color: #7fae9d;
  background: #edf6f2;
  box-shadow: inset 0 0 0 1px #7fae9d;
}

.batch-list button.selected .check {
  border-color: #176d54;
  background: #176d54;
}

.batch-list strong, .batch-list small, .batch-list em, .empty-inline {
  font-size: 11px;
}

.batch-list .batch-blocker {
  color: #9a6136;
}

.freeze-grid aside {
  background: #f7faf8;
}

.freeze-grid label span, .freeze-grid dt, .freeze-grid dd {
  color: #667770;
  font-size: 11px;
}

.freeze-grid input {
  font-size: 12px;
}

.freeze-grid aside > button, .version-list > article > header button {
  min-height: 36px;
  background: #176d54;
  font-size: 11px;
}

.version-list > article {
  border-color: #e0e7e4;
}

.version-list > article > header span {
  color: #263b32;
  font-size: 14px;
}

.version-list > article > header em {
  color: #176d54;
  background: #e7f3ee;
  font-size: 10px;
}

.version-list dt, .artifact-list span {
  font-size: 10px;
}

.version-list dd, .version-list code, .artifact-list strong, .artifact-list p {
  color: #4f625a;
  font-size: 11px;
}

@media (max-width: 760px) {
  .release-page {
    margin: 14px;
    padding: 0 16px 18px;
  }
  .page-heading {
    margin: 0 -16px;
    padding: 14px 16px;
  }
  .page-heading, .page-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .page-actions select {
    width: 100%;
    min-width: 0;
  }
}`],
})
export class PageAuthoringReleasesComponent implements OnInit {
    public loading: boolean = true;
    public freezing: boolean = false;
    public exportingId: string = '';
    public datasets: any[] = [];
    public selectedDatasetId: string = '';
    public batches: any[] = [];
    public versions: any[] = [];
    public policy: any = {};
    public selectedBatchIds: string[] = [];
    public form: any = this.newForm();

    constructor(@Inject( Service) public service: Service) { }

    public newKey(prefix: string) {
        return prefix + '-' + Date.now().toString(36) + '-'
            + Math.random().toString(36).substring(2, 10);
    }

    public newForm() {
        let date = currentKstDateCompact();
        let version = 'v' + date.substring(0, 4) + '.'
            + date.substring(4, 6) + '.' + date.substring(6, 8);
        return {
            version: version,
            idempotency_key: this.newKey('freeze-version')
        };
    }

    public async ngOnInit() {
        await this.service.init();
        await this.loadDatasets();
        await this.load();
    }

    public selectedDataset() {
        return this.datasets.find((dataset: any) => dataset.id === this.selectedDatasetId) || null;
    }

    public canRelease() {
        let roles = (this.selectedDataset() || {}).roles || [];
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN'
            || roles.indexOf('RELEASE_ADMIN') >= 0;
    }

    public async loadDatasets() {
        let result: any = await this.service.request.post('/api/datasets/list');
        if (result.code !== 200) {
            this.datasets = [];
            return;
        }
        this.datasets = result.data.datasets || [];
        let current = this.service.auth.session.current_dataset || {};
        if (!this.datasets.some((dataset: any) => dataset.id === this.selectedDatasetId)) {
            this.selectedDatasetId = this.datasets.some((dataset: any) => dataset.id === current.dataset_id)
                ? current.dataset_id : (this.datasets[0] || {}).id || '';
        }
    }

    public async selectDataset() {
        this.selectedBatchIds = [];
        this.batches = [];
        this.versions = [];
        this.policy = {};
        this.form = this.newForm();
        await this.load();
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: 'Dataset Release 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    public async load() {
        if (!this.selectedDatasetId || !this.canRelease()) {
            this.loading = false;
            await this.service.render();
            return;
        }
        this.loading = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/releases/prepare', {
                dataset_id: this.selectedDatasetId
            });
            if (result.code !== 200) {
                await this.showError(result.data && result.data.message ? result.data.message : 'Release 정보를 불러오지 못했습니다.');
                return;
            }
            this.batches = result.data.batches || [];
            this.versions = result.data.versions || [];
            this.policy = result.data.policy || {};
            this.selectedBatchIds = this.selectedBatchIds.filter(
                (id: string) => this.batches.some(
                    (batch: any) => batch.id === id && batch.release_ready
                )
            );
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public selected(id: string) {
        return this.selectedBatchIds.indexOf(id) >= 0;
    }

    public releaseReadyBatches() {
        return this.batches.filter((batch: any) => batch.release_ready);
    }

    public batchBlockerLabel(batch: any) {
        let labels: any = {
            APPROVED_REVISION_SET_INVALID: '승인 결과 스냅샷을 다시 생성해야 합니다.',
            CANDIDATE_SNAPSHOT_V2_REQUIRED: '후보 원문 스냅샷을 보완해야 합니다.',
            EXPERT_RFP_ANNOTATION_REQUIRED: '승인 QA의 전문가 RFP 분류·검수 확인이 필요합니다.'
        };
        let blockers = batch.blockers || [];
        return blockers.map((code: string) => labels[code] || code).join(' ') || '발행 조건을 확인해 주세요.';
    }

    public async toggleBatch(batch: any) {
        if (!batch.release_ready || this.freezing) return;
        let index = this.selectedBatchIds.indexOf(batch.id);
        if (index >= 0) this.selectedBatchIds.splice(index, 1);
        else if (this.selectedBatchIds.length < Number(this.policy.batch_max || 20)) {
            this.selectedBatchIds.push(batch.id);
        }
        this.selectedBatchIds = this.selectedBatchIds.slice();
        await this.service.render();
    }

    public selectedAcceptedCount() {
        return this.batches
            .filter((batch: any) => this.selected(batch.id))
            .reduce((total: number, batch: any) => total + Number(batch.accepted_count || 0), 0);
    }

    public async freeze() {
        if (this.freezing) return;
        if (!this.selectedBatchIds.length) {
            await this.showError('종료된 Review Batch를 하나 이상 선택해 주세요.');
            return;
        }
        if (!this.form.version || !this.form.version.trim()) {
            await this.showError('Dataset Version 이름을 입력해 주세요.');
            return;
        }
        let confirmed = await this.service.modal.show({
            title: 'Dataset Version 동결',
            message: this.selectedAcceptedCount() + '개 승인 QA의 Candidate·Revision·Evidence 계보를 변경 불가 상태로 동결합니다.',
            cancel: '취소',
            action: '동결',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;

        this.freezing = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/releases/freeze', {
                dataset_id: this.selectedDatasetId,
                version: this.form.version,
                batch_ids: this.selectedBatchIds.join(','),
                idempotency_key: this.form.idempotency_key
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.showError(result.data && result.data.message ? result.data.message : 'Dataset Version을 동결하지 못했습니다.');
                return;
            }
            await this.service.modal.show({
                title: result.data.created ? '동결 완료' : '동일 요청 확인',
                message: result.data.version.version + ' · content hash ' + this.shortHash(result.data.version.content_hash),
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
            this.form = this.newForm();
            this.selectedBatchIds = [];
            await this.load();
        } finally {
            this.freezing = false;
            await this.service.render();
        }
    }

    public async exportVersion(version: any) {
        if (this.exportingId || version.status !== 'FROZEN') return;
        let confirmed = await this.service.modal.show({
            title: '공식 Export 생성',
            message: version.version + '을 JSONL·XLSX·Manifest 공식 산출물로 생성하고 RELEASED 상태로 전환합니다.',
            cancel: '취소',
            action: 'Export',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;

        this.exportingId = version.id;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/releases/export', {
                dataset_id: this.selectedDatasetId,
                version_id: version.id,
                idempotency_key: this.newKey('official-export')
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.showError(result.data && result.data.message ? result.data.message : '공식 Export를 생성하지 못했습니다.');
                return;
            }
            await this.load();
            await this.service.modal.show({
                title: '공식 Export 완료',
                message: 'qa_dataset.jsonl, qa_dataset.xlsx, manifest.json의 SHA-256 해시를 고정했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.exportingId = '';
            await this.service.render();
        }
    }

    public statusLabel(value: string) {
        let labels: any = {
            FROZEN: '동결',
            EXPORTING: '내보내는 중',
            RELEASED: '출시 완료',
            WITHDRAWN: '철회'
        };
        return labels[value] || value;
    }

    public shortHash(value: string) {
        return value ? value.substring(0, 12) : '-';
    }

    public artifactName(uri: string) {
        if (uri.endsWith('manifest.json')) return 'manifest.json';
        if (uri.endsWith('qa_dataset.xlsx')) return 'qa_dataset.xlsx';
        return 'qa_dataset.jsonl';
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '-');
    }
}

export default PageAuthoringReleasesComponent;